import { Message, toaster } from 'rsuite';
import React from 'react';

const DEFAULT_DURATION = 2000;

export function showSuccessMessage(message: string, duration: number = DEFAULT_DURATION): void {
  toaster.push(
    <Message
      type="success"
      closable
      showIcon
    >
      {message}
    </Message>,
    { duration },
  );
}

export function showErrorMessage(message: string, duration: number = DEFAULT_DURATION): void {
  toaster.push(
    <Message
      type="error"
      closable
      showIcon
    >
      {message}
    </Message>,
    { duration },
  );
}
